import Vue from 'vue'
import Router from './Router'

export default {
	namespaced: true,
	state: {
		agencies: [],
		meta: null,
		loading: true,
		detail: {},
		isLoadCrate: false,
		isLoadingDetail: false
	},
	actions: {
		async fetch({ commit }, query) {
			let response = await Vue.http.get('agencies', { params: query })
			commit('setList', response.body)
		},
		async fetchOne({ commit, rootState }) {
			try {
				commit('setLoadDetail', true)
				let id = rootState.route.params.agencyId
				let response = await Vue.http.get(`agencies/${id}`)
				commit('setDetail', response.body)
				commit('setLoadDetail', false)
			} catch (e) {
				commit('setLoadDetail', false)
			}
		},
		async createAgency({ commit }, data) {
			try {
				commit('setLoadCreate', true)
				const response = await Vue.http.post(`agencies`, data)
				Router.push(`agencies/${response.body.id}`)
				commit('setLoadCreate', false)
			} catch (e) {
				commit('setLoadCreate', false)
				console.error(e)
			}
		},
		async updateAgency({ dispatch, rootState }, data) {
			let id = rootState.route.params.agencyId
			await Vue.http.post(`agencies/${id}`, data)
			dispatch('fetchOne')
		},

		async createAddress({ rootState, commit }, data) {
			const id = rootState.route.params.agencyId
			let response = await Vue.http.post(`addresses`, { ...data, addressable_id: id })
			data.id = response.body.addressId
			commit('addAddress', data)
		},
		async updateAddress({ commit }, data) {
			await Vue.http.post(`addresses/${data.id}`, data)
			commit('updateAddress', data)
		},
		async deleteAddress({ commit }, id) {
			await Vue.http.delete(`addresses/${id}`)
			commit('deleteAddress', id)
		}
	},
	mutations: {
		setList(state, agencies) {
			state.agencies = agencies.data
			state.meta = agencies.meta
			state.loading = false
		},
		setDetail(state, agency) {
			state.detail = agency
		},
		setLoadCreate(state, status) {
			state.isLoadCrate = status
		},
		setLoadDetail(state, status) {
			state.isLoadingDetail = status
		},
		addContact(state, contact) {
			state.detail.contacts = state.detail.contacts
				? [...state.detail.contacts, contact]
				: [contact]
		},
		deleteContact(state, contact) {
			state.detail.contacts = state.detail.contacts.filter(
				item => item.name + item.value !== contact.name + contact.value
			)
		},

		addAddress(state, address) {
			state.detail.agency_address = [address]
		},
		updateAddress(state, address) {
			state.detail.agency_address = state.detail.agency_address.map(
				item => {
					if(item.id === address.id) {
						item = address
					}
					return item
				}
			)
		},
		deleteAddress(state, addressId) {
			state.detail.agency_address = state.detail.agency_address.filter(
				item => item.id !== addressId
			)
		}
	}
}
